import type { GridColumnProps } from '../types'

export function getDefaultSeqColumn(): GridColumnProps {
  return { type: 'seq', title: '#' }
}

/**
 * 序号列由 grid 自动插入为第一列；用户配置中的 seq 会被剔除（最多允许声明 1 个，多于 1 个抛错）。
 */
export function normalizeGridColumnProps(columns: GridColumnProps[]): GridColumnProps[] {
  const seqCount = columns.filter((col) => col.type === 'seq').length
  if (seqCount > 1) {
    throw new Error(
      '[GridOption] seq column is auto-generated as the first column; only one seq column definition is allowed'
    )
  }
  const rest = columns.filter((col) => col.type !== 'seq')
  return [getDefaultSeqColumn(), ...rest]
}
